import {Slot, Text, Trail, Typography} from '@yandex-delivery/blocks'
import clsx from 'clsx'

import {classes} from './ExtraItemSlot.classes'
import type {ExtraItemProps} from './ExtraItemSlot.types'

export function ExtraItemSlot({title, description, children, disabled, onClick}: ExtraItemProps): React.ReactElement {
  return (
    <Slot className={clsx({[classes.pointer]: onClick}, {[classes.disabled]: disabled})} onPointerUp={onClick} size="l">
      <Text className={classes.body}>
        <Typography thickness="regular" variant="body2">
          {title}
        </Typography>
        {description && (
          <Typography color="minor" variant="caption1">
            {description}
          </Typography>
        )}
      </Text>
      <Trail>{children}</Trail>
    </Slot>
  )
}
